import '@albelli/arc-3/lib/price.css';
import '@albelli/arc-3/lib/forms.css';
import '@albelli/arc-3/lib/buttons.css';
import '@albelli/arc-3/lib/callout_label.css';
import '@albelli/arc-3/lib/icon.css';
import '../../style/main.scss';
import '../../style/offer-block.scss';
import '../../style/voucher-block.scss';

import useVendor from '../../hooks/useVendor';

import CalendarIcon from './calendarIcon';
import DateFormat from '../date/dateFormat';
import { Button } from '@albelli/arc-3-react/lib/Button';
import currencyFormatter from '../../helpers/currencyFormatter';
import { getDiscountPercentage } from '../../helpers/discountPercentage';
import { checkoutHandler } from '../../helpers/bnclCheckout';
import { Alert } from '@albelli/arc-3-react/lib/Alert';
import { useState } from 'preact/hooks';
import Trans from '../translations/trans';
import { domainPrefix } from '../../config/domainPrefix';
import { Voucher } from '../../types/voucher';

const VoucherBlock = ({ offer, key }: { offer: Voucher; key: string }) => {
    const [error, setError] = useState(false);
    const vendor = useVendor();
    const imageUrl = new URL(`${offer.imagePath}?d=559x447`, `https://${domainPrefix}${vendor}`);
    const handleCheckout = async (e) => {
        e.preventDefault();
        const result = await checkoutHandler(offer, vendor);
        setError(result.error);
        setTimeout(() => setError(false), 5000);
    };

    return (
        <div className='offer-block voucher-block --flex-wrapper arc3-padding--left-lger arc3-padding--right-lger'>
            <div className='offer-block__wrapper --top arc3-flex-wrapper voucher-block__voucher-image-block'>
                <picture>
                    <img src={imageUrl.href} width='559' height='447' />
                </picture>
            </div>
            <div className='voucher-block__title arc3-margin--left'>
                <p className='offer-block__title arc3-typo--font-bold arc3-margin--top arc3-no-margin--bottom'>
                    {offer.productBlockTitle}
                </p>
            </div>
            <div className='arc3-price voucher-block__price-wrapper'>
                <p className='arc3-price__discounted arc3-typo--font-bold voucher-price'>
                    {' '}
                    {currencyFormatter(offer.voucherPrice, vendor)}
                </p>
                <p className='arc3-price__full arc3-typo--font-bold arc3-padding--left voucher-price-base'>
                    {currencyFormatter(offer.productPrice, vendor)}
                </p>
                <p className='arc3-typo--text-uppercase arc3-price__percentage-discount arc3-padding--right voucher-price-percentage'>
                    {`-${getDiscountPercentage(offer.productPrice, offer.voucherPrice)}%`}
                </p>
            </div>
            <div className='voucher-block__valid-date'>
                <CalendarIcon />
                <DateFormat isoDateFormattedString={offer.expirationDate} dateFormatTransKey='voucher.expirationTime' />
            </div>
            <ul className='arc3-typo-checklist arc3-padding--top-lg arc3-no-padding--left arc3-no-margin --cyan'>
                {offer.includedOptions.map((option, index) => (
                    <li key={index}>{option}</li>
                ))}
            </ul>
            <ul className='arc3-typo-crosslist arc3-padding--bottom-lg arc3-no-padding--left arc3-no-margin voucher-block__excluded-options'>
                {offer.excludedOptions.map((option, index) => (
                    <li key={index}>{option}</li>
                ))}
            </ul>

            <div className={'offer-block__wrapper --voucher-button-wrapper arc3-padding--bottom-lg arc3-padding-top'}>
                {error ? (
                    <Alert error className='voucher-alert arc3-padding--bottom'>
                        <Trans transKey='voucher.error.checkout' />
                    </Alert>
                ) : (
                    <Button className='arc3-btn arc3-full-width' onClick={handleCheckout}>
                        <i className='arc3-icon voucher-block__cart_icon'>shopping_cart</i>
                        <Trans transKey='voucher.checkoutButton' />
                    </Button>
                )}
            </div>
        </div>
    );
};

export default VoucherBlock;
